/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  var focusableSelector = 'a, button, input, select, textarea, [tabindex]';

  function syncSlideFocus(slide) {
    var isHidden = slide.getAttribute('aria-hidden') === 'true';

    slide.querySelectorAll(focusableSelector).forEach(function (element) {
      if (isHidden) {
        if (!element.hasAttribute('data-cosmos-tabindex')) {
          element.setAttribute('data-cosmos-tabindex', element.getAttribute('tabindex') || '');
        }
        element.setAttribute('tabindex', '-1');
      } else if (element.hasAttribute('data-cosmos-tabindex')) {
        var previousTabindex = element.getAttribute('data-cosmos-tabindex');

        if (previousTabindex === '') {
          element.removeAttribute('tabindex');
        } else {
          element.setAttribute('tabindex', previousTabindex);
        }

        element.removeAttribute('data-cosmos-tabindex');
      }
    });
  }

  function initializeCarouselFocus() {
    document.querySelectorAll('.flickity-slider > [aria-hidden]').forEach(syncSlideFocus);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
          syncSlideFocus(mutation.target);
        }
      });
    }).observe(document.body, {
      attributes: true,
      attributeFilter: ['aria-hidden'],
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCarouselFocus);
  } else {
    initializeCarouselFocus();
  }
})();
